module.exports = {
    name:      "japan",
    buildDate: "Fri Nov 30 2018 10:13:50 GMT+0000 (UTC)",
    version:   "1.0.0",
    build:     "19.2204 debug"
};



//////////////////
// WEBPACK FOOTER
// ./src/version.js
// module id = 9
// module chunks = 0